export default [
  {
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/admin/dashboard'
  },
  {
    name: 'Licenses',
    icon: 'ti-unlock',
    path: '/admin/licenses'
  },
  {
    name: 'Decrypt Keys',
    icon: 'ti-key',
    path: '/admin/decrypt-keys'
  },
  {
    name: 'VOD sets',
    icon: 'ti-blackboard',
    path: '/admin/vodsets'
  },
  {
    name: 'Grab Servers',
    icon: 'ti-server',
    path: '/admin/servers'
  },
  {
    name: 'Grab Jobs',
    icon: 'ti-pulse',
    path: '/admin/grabjobs'
  },
  // {
  //   name: 'Channels',
  //   icon: 'ti-signal',
  //   path: '/admin/channels'
  // },
  {
    name: 'Data Viewer',
    icon: 'ti-filter',
    path: '/admin/dataviewer/tv',
    children: [
      {
        name: 'TV guide',
        path: '/admin/dataviewer/tv'
      },
      {
        name: 'VOD guide',
        path: '/admin/dataviewer/vod'
      }
    ]
  },
  {
    name: 'Logbook',
    icon: 'ti-agenda',
    path: '/admin/logbook'
  },
  {
    name: 'Settings',
    icon: 'ti-settings',
    path: '/admin/settings'
  },
  // {
  //   name: 'Dashboard',
  //   icon: 'ti-panel',
  //   collapsed: false,
  //   children: [{
  //     name: 'Overview',
  //     path: '/admin/overview'
  //   },
  //   {
  //     name: 'Stats',
  //     path: '/admin/stats'
  //   }]
  // },
  // {
  //   name: 'Components',
  //   icon: 'ti-package',
  //   children: [{
  //     name: 'Buttons',
  //     path: '/components/buttons'
  //   },
  //   {
  //     name: 'Grid System',
  //     path: '/components/grid-system'
  //   },
  //   {
  //     name: 'Panels',
  //     path: '/components/panels'
  //   },
  //   {
  //     name: 'Sweet Alert',
  //     path: '/components/sweet-alert'
  //   },
  //   {
  //     name: 'Notifications',
  //     path: '/components/notifications'
  //   },
  //   {
  //     name: 'Icons',
  //     path: '/components/icons'
  //   },
  //   {
  //     name: 'Typography',
  //     path: '/components/typography'
  //   }]
  // },
  // {
  //   name: 'Forms',
  //   icon: 'ti-clipboard',
  //   children: [{
  //     name: 'Regular Forms',
  //     path: '/forms/regular'
  //   },
  //   {
  //     name: 'Extended Forms',
  //     path: '/forms/extended'
  //   },
  //   {
  //     name: 'Validation Forms',
  //     path: '/forms/validation'
  //   },
  //   {
  //     name: 'Wizard',
  //     path: '/forms/wizard'
  //   }
  //   ]
  // },
  // {
  //   name: 'Table List',
  //   icon: 'ti-view-list-alt',
  //   collapsed: true,
  //   children: [{
  //     name: 'Regular Tables',
  //     path: '/table-list/regular'
  //   },
  //   {
  //     name: 'Extended Tables',
  //     path: '/table-list/extended'
  //   },
  //   {
  //     name: 'Paginated Tables',
  //     path: '/table-list/paginated'
  //   }
  //   ]
  // },
  // {
  //   name: 'Maps',
  //   icon: 'ti-map',
  //   children: [{
  //     name: 'Google Maps',
  //     path: '/maps/google'
  //   },
  //   {
  //     name: 'Full Screen Maps',
  //     path: '/maps/full-screen'
  //   },
  //   {
  //     name: 'Vector Maps',
  //     path: '/maps/vector-map'
  //   }
  //   ]
  // },
  // {
  //   name: 'Charts',
  //   icon: 'ti-gift',
  //   path: '/charts'
  // },
  // {
  //   name: 'Calendar',
  //   icon: 'ti-calendar',
  //   path: '/calendar'
  // },
  // {
  //   name: 'Pages',
  //   icon: 'ti-gift',
  //   children: [{
  //     name: 'User Page',
  //     path: '/pages/user'
  //   },
  //   {
  //     name: 'Timeline Page',
  //     path: '/pages/timeline'
  //   },
  //   {
  //     name: 'Login Page',
  //     path: '/login'
  //   },
  //   {
  //     name: 'Register Page',
  //     path: '/register'
  //   },
  //   {
  //     name: 'Lock Page',
  //     path: '/lock'
  //   }
  //   ]
  // }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js